<template>
  <wo-layout>
    <po-error-display :value="error"  mod-scroll />
    <form autocomplete="off">
      <wo-card :title="$t('general.info')">
        <wo-properties mod-horizontal mod-bordered v-focus="true">

          <template v-if="newEntity">
            <wo-properties-label><wo-label v-t="'user.email'"></wo-label></wo-properties-label>
            <wo-properties-value><po-input-field name="email" v-model="pending.email" type="email" /></wo-properties-value>

            <wo-properties-label><wo-label v-t="'admin.user.credentials.title'"></wo-label></wo-properties-label>
            <wo-properties-value>
              <wo-checkbox v-model="pending.allow_login"><span v-t="'admin.user.credentials.createPassword'"></span></wo-checkbox>
            </wo-properties-value>

            <wo-properties-label><wo-label v-t="'user.company'"></wo-label></wo-properties-label>
            <wo-properties-value>
              <po-selector v-model="pending.company" :search="searchCompany" :required="true" :label-factory="createCompanyLabel" />
            </wo-properties-value>
          </template>

          <wo-properties-label><wo-label v-t="'user.firstName'"></wo-label></wo-properties-label>
          <wo-properties-value><po-input-field name="firstName" v-model="pending.first_name" /></wo-properties-value>

          <wo-properties-label><wo-label v-t="'user.lastName'"></wo-label></wo-properties-label>
          <wo-properties-value><po-input-field name="lastName" v-model="pending.last_name" /></wo-properties-value>

          <wo-properties-label><wo-label v-t="'user.locale'"></wo-label></wo-properties-label>
          <wo-properties-value><po-input-field name="locale" v-model="pending.locale" message-key="user.localeMessage"/></wo-properties-value>
        </wo-properties>
      </wo-card>
      <po-confirmation-buttons @confirm="confirm" @cancel="emitCancel" :valid="valid" v-focus="true" />
    </form>
  </wo-layout>
</template>

<script>

import { User } from '@/model/identity'

import { userRepository } from '@/repository/identity'
import { companyRepository } from '@/repository/company'

import editor from '@/mixins/editor'

export default {
  mixins: [ editor ],
  props: {
    value: User
  },
  computed: {
    valid () {
      const u = this.pending
      return u.first_name && u.last_name && u.locale
    }
  },
  created () {
    this.pending = new User(this.value)
    if (this.newEntity) {
      this.pending.allow_login = true
    }
  },
  methods: {
    confirm ({ detail }) {
      const action = this.newEntity ? userRepository.create : userRepository.update
      this.$store.dispatch(action, { entity: this.pending })
        .then(this.emitInput, this.editFailed)
        .finally(detail.resolve)
    },
    searchCompany (searchText) {
      const filter = { search_text: searchText }
      return this.$store.dispatch(companyRepository.findAll, { filter })
    },
    createCompanyLabel: (option) => option.fullDisplayName
  }
}
</script>
